// extracted by mini-css-extract-plugin
export var fadeIn = "_fd-1";
export var modalContent = "_fd-3";
export var overlay = "_fd-0";
export var popoverContent = "_fd-2";
export var results = "_fd-5";
export var searchInputWrapper = "_fd-4";